<template>
  <el-dialog
    :width="width"
    :title="title"
    :visible.sync="visible"
    :before-close="close"
    :close-on-click-modal="false"
    custom-class="msg-tips-dialog"
  >
    <div slot="title">
      <span class="icon-warning el-icon-warning"></span>
      <span class="title">{{ title }}</span>
    </div>
    <div v-if="data && data.length" class="msg-tips-main">
      <p class="msg-tips-row" v-for="(item, index) in data" :key="index">
        <span class="msg-tips-dot"></span>
        <span class="msg-tips-msg-tips-main">{{ item }}</span>
      </p>
    </div>
    <div slot="footer" class="msg-tips-footer">
      <el-button type="primary" @click="close" :size="$elsize">
        确 认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "msg-tips",
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false,
    // },
    title: {
      type: [Number, String],
      default: "提示",
    },
    data: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: "30%",
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    close(done) {
      if (typeof done === "function") {
        done();
      }
      this.visible = false;
      // this.$el.parentNode.removeChild(this.$el);
      this.$emit("confirm");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .msg-tips-dialog .el-dialog__body {
  padding-right: 0 !important;
  .msg-tips-main {
    margin-right: 0;
  }
}
.msg-tips-main {
  width: 90%;
  margin: auto;
  max-height: 50vh;
  overflow: auto;
}
.msg-tips-row {
  margin: 8px 0;
}
.msg-tips-row:first-of-type,
.msg-tips-row:last-of-type {
  margin-top: 0;
}
.msg-tips-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e0371c;
  vertical-align: middle;
}
.msg-tips-msg-tips-main {
  color: #666;
  vertical-align: middle;
  margin-left: 8px;
}
.icon-warning {
  font-size: 21px;
  color: #e0371c;
  vertical-align: middle;
}
.title {
  font-size: 16px;
  margin-left: 8px;
  color: #333;
  vertical-align: middle;
}
</style>
